<template>
    <div v-if="is_show" class="box" :style="`background-image:url(${$OSSBaseUrl}renew.png)`">
        <img class="bg_img" :src="$OSSBaseUrl+'renew_bg.png'">
        <Popup :popup_style="popup_style">
            <img class="tips_img" :src="$OSSBaseUrl+($config.SystemOS=='IOS'?'renew_tips_ios.png':'renew_tips_android.png')">
        </Popup>
    </div>
</template>
<script>
import { Toast } from 'vant';
import Popup from '@/components/Popup';

export default {
    name:'Renew',
    data(){
        let popup_style='background-color:rgba(0,0,0,0.7)';
        return{
            is_show: false,
            popup_style,
        }
    },
    components:{
        Popup
    },
    created(){
        let data = {
            page_from:'main_page',
            page_name:'Renew',
            page_time:'0.00',
            receiver_id: '',
            page_param:{dayhour:this.$route.query.dayhour},
        };
        this.$store.dispatch('Public/inH5Record', data).then(res=>{
            this.is_show = true;
        });
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>